module.exports = __webpack_public_path__ + "static/media/ico-audio.c5bd07bb.svg";